var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { MyListButton } from "core/components";
import { Airing } from "core/components/Airing";
import useEnteredViewport from "core/customHooks/useEnteredViewport";
import { colors } from "core/styles/snippets";
import { Id, config, content, gtm, truncate } from "core/utils";
import * as Option from "fp-ts/lib/Option";
import { getStaticCtaVariant } from "hero/ProgramStaticHero/getStaticCtaVariant";
import { prepView as prepHeroView } from "hero/View";
import { Cta } from "hero/components";
import { Container, Description, HeroBoxCover, HeroBoxCoverContainer, HeroTime, Title, Wrapper, } from "hero/components/Content";
import { getHeroCategory, getHeroList, getHeroVariant } from "hero/utils/hero";
import { useOptTimer } from "hero/utils/timed";
import { trackHero } from "hero/utils/tracking";
import React, { useState } from "react";
import styled from "styled-components";
var Content = function (_a) {
    var _b, _c;
    var data = _a.data, trackingEnabled = _a.trackingEnabled, votingEnabled = _a.votingEnabled;
    var _d = useState(getStaticCtaVariant(data)), ctaVariant = _d[0], setCtaVariant = _d[1];
    var _e = useEnteredViewport(config.tracking.impressionThreshold.hero), ref = _e.ref, enteredViewport = _e.enteredViewport;
    var updateCtaState = function () {
        setCtaVariant(getStaticCtaVariant(data));
    };
    useOptTimer("GO_BUTTON_LIVE", ctaVariant.kind === "VtmGoLive"
        ? Option.some(ctaVariant.updateTime)
        : Option.none, updateCtaState);
    useOptTimer("GO_BUTTON_ON_DEMAND", ctaVariant.kind === "VtmGoOnDemand" ? ctaVariant.updateTime : Option.none, updateCtaState);
    if (trackingEnabled && enteredViewport) {
        trackHero(config.tracking.listNames.programHero, getHeroVariant(data, ctaVariant), getHeroCategory(data), data.program, data);
    }
    return (React.createElement(Container, { "$airing": data.airing, "$description": data.description, "$boxCover": data.boxCoverImage, ref: ref },
        data.boxCoverImage && (React.createElement(HeroBoxCoverContainer, null,
            React.createElement(HeroBoxCover, { image: data.boxCoverImage, alt: "boxcover van ".concat(data.title) }))),
        React.createElement(Wrapper, { "$airing": data.airing, "$boxCover": data.boxCoverImage },
            React.createElement(HeroTime, { "$airing": data.airing, "$boxCover": data.boxCoverImage }, data.airing && (React.createElement(Airing, { airing: __assign(__assign({}, data.airing), { info: data.airing.info || undefined }), broadcast: data.nextBroadcast || undefined, channel: data.channel, hasAppendedLogo: true }))),
            React.createElement(Title, { "$airing": data.airing, "$description": data.description, "$boxCover": data.boxCoverImage }, data.title),
            data.description && !votingEnabled && (React.createElement(Description, { "$length": (_b = data.description) === null || _b === void 0 ? void 0 : _b.length }, truncate(config.characterLimit.heroDescription, data.description))),
            React.createElement(CtaWrapper, { "$description": data.description },
                React.createElement(StyledCta, { variant: ctaVariant, channel: data.channel, trackingObject: {
                        list: ctaVariant.kind === "VtmGoLive" ||
                            ctaVariant.kind === "VtmGoOnDemand"
                            ? "vtm-go-hero"
                            : getHeroList(data),
                        product: {
                            id: data.program,
                            name: data.title,
                            category: getHeroCategory(data),
                            variant: getHeroVariant(data, ctaVariant),
                        },
                    } }),
                data.vtmgoUrl &&
                    ["VtmGoOnDemand", "VtmGoLive"].includes(ctaVariant.kind) && (React.createElement(StyledListButton, { url: config.urls.vtmgoMyList(data.vtmgoUrl), "data-component": Id.component.hero.myListButton, "data-gtm": gtm.attribute.hero.listButton, trackingObject: {
                        list: "vtm-go-hero-add-to-my-list",
                        product: {
                            id: data.program,
                            name: (_c = data.title) !== null && _c !== void 0 ? _c : "",
                            category: getHeroCategory(data),
                            variant: getHeroVariant(data, ctaVariant),
                        },
                    } }, content.episodes.listButton.label))))));
};
var CtaWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  grid-area: buttons;\n"], ["\n  display: flex;\n  grid-area: buttons;\n"])));
var StyledCta = styled(Cta)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  pointer-events: auto;\n"], ["\n  pointer-events: auto;\n"])));
var StyledListButton = styled(MyListButton)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  margin-left: 0.5rem;\n  pointer-events: auto;\n  grid-area: buttons;\n  background-color: ", ";\n"], ["\n  margin-left: 0.5rem;\n  pointer-events: auto;\n  grid-area: buttons;\n  background-color: ", ";\n"])), colors.black);
export var ProgramStaticHero = function (_a) {
    var hero = _a.hero, trackingEnabled = _a.trackingEnabled, votingEnabled = _a.votingEnabled;
    var Hero = prepHeroView(function () { return (React.createElement(Content, { data: hero, trackingEnabled: trackingEnabled, votingEnabled: votingEnabled })); });
    return (React.createElement(Hero, { "data-result": Id.result.success, data: hero, votingEnabled: votingEnabled }));
};
var templateObject_1, templateObject_2, templateObject_3;
